<template>
  <mdb-container class="main-container">
    <h1 class="h1-responsive my-5 text-center"><strong>Самые популярные споты Ульяновска</strong></h1>
    <section class="mb-3">
      <mdb-row>
        <mdb-col lg="4">
          <mdb-view ref="frameView" class="rounded z-depth-2 mb-lg-0 mb-4" hover>
            <spot-frame
              v-if="loadFrames"
              :width="frameWidth"
              :height="frameWidth"
              :src="frameSrc1"
              frameborder="0"
            ></spot-frame>
          </mdb-view>
        </mdb-col>
        <mdb-col lg="8">
          <a class="blue-text">
            <h6 class="h6-responsive mb-3">
              <mdb-icon icon="arrow-down" class="pr-2" />С
              <mdb-icon icon="arrow-right" class="pr-2 pl-3" />З
              <mdb-icon icon="arrow-up" class="pr-2 pl-3" />Ю
            </h6>
          </a>
          <h3 class="h3-responsive mb-3 p-0">
            <strong>Поселок Рыбацкий</strong>
          </h3>
          <p><strong>Каталка по Волге, спуск в районе "Розы ветров"</strong></p>
          <p>
            Северные, западные и южные ветра дуют здесь беспрепятственно. Ровный ветер и бескрайние просторы реки.
          </p>
        </mdb-col>
      </mdb-row>
      <hr class="my-3" />
      <mdb-row>
        <mdb-col lg="8">
          <a class="blue-text">
            <h6 class="h6-responsive mb-3">
              <mdb-icon icon="arrow-down" class="pr-2" />С
              <mdb-icon icon="arrow-left" class="pr-2 pl-3" />В
            </h6>
          </a>
          <h3 class="h3-responsive mb-3 p-0">
            <strong>Бирючевка</strong>
          </h3>
          <p><strong>Открытое поле</strong></p>
          <p>Неплохо дуют северный и восточные ветра</p>
        </mdb-col>
        <mdb-col lg="4">
          <mdb-view class="rounded z-depth-2 mb-lg-0 mb-4" hover>
            <spot-frame
              v-if="loadFrames"
              :width="frameWidth"
              :height="frameWidth"
              :src="frameSrc2"
              frameborder="0"
            ></spot-frame>
          </mdb-view>
        </mdb-col>
      </mdb-row>
      <hr class="my-5" />
      <mdb-row>
        <mdb-col lg="4">
          <mdb-view class="rounded z-depth-2 mb-lg-0 mb-4" hover>
            <spot-frame
              v-if="loadFrames"
              :width="frameWidth"
              :height="frameWidth"
              :src="frameSrc3"
              frameborder="0"
            ></spot-frame>
          </mdb-view>
        </mdb-col>
        <mdb-col lg="8">
          <a class="blue-text">
            <h6 class="h6-responsive mb-3">
              <mdb-icon icon="arrow-down" class="pr-2" />С
              <mdb-icon icon="arrow-left" class="pr-2 pl-3" />В
              <mdb-icon icon="arrow-up" class="pr-2 pl-3" />Ю
              <mdb-icon icon="arrow-right" class="pr-2 pl-3" />З
            </h6>
          </a>
          <h3 class="h3-responsive mb-3 p-0">
            <strong>Кременки</strong>
          </h3>
          <p><strong>Коса в районе "Славянского Подворья"</strong></p>
          <p>Отличный спот для виндсерфинга.</p>
          <p>Ровный ветер практически в любом направлении.</p>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbMask, mdbView, mdbIcon } from 'mdbvue'
import SpotFrame from '../SpotFrame'
export default {
  name: 'SpotsPage',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
    mdbIcon,
    SpotFrame
  },
  data: function () {
    return {
      frameWidth: 0,
      loadFrames: false,
      frameSrc1: 'https://embed.windy.com/embed2.html?lat=54.373&lon=48.538&zoom=12&level=surface&overlay=wind&menu=&message=&marker=&calendar=now&pressure=&type=map&location=coordinates&detail=true&detailLat=54.390&detailLon=48.518&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1',
      frameSrc2: 'https://embed.windy.com/embed2.html?lat=54.407&lon=48.096&zoom=12&level=surface&overlay=wind&menu=&message=&marker=&calendar=now&pressure=&type=map&location=coordinates&detail=true&detailLat=54.403&detailLon=48.108&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1',
      frameSrc3: 'https://embed.windy.com/embed2.html?lat=54.500&lon=48.852&zoom=12&level=surface&overlay=wind&menu=&message=&marker=&calendar=now&pressure=&type=map&location=coordinates&detail=true&detailLat=54.500&detailLon=48.852&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1'
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.loadFrames = true
      this.frameWidth = this.$refs.frameView.$el.clientWidth
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/SpotsPage.vue